import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, intakeComplete, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/register" replace />;
  }

  if (!intakeComplete) {
    return <Navigate to="/intake" replace />;
  }

  return children;
}
